import { setPaginationSlide } from './setPaginationSlide';

export const carouselState = ({
  carouselListWidth,
  carouselPadding,
  carouselWidth,
  slideActive,
  slidesTotal,
  assetFormat,
}: {
  carouselListWidth: number;
  carouselPadding: number;
  carouselWidth: number;
  slideActive: number;
  slidesTotal: number;
  assetFormat: string;
}) => {
  const paginationShow = carouselListWidth > carouselWidth - carouselPadding;
  const { desktop, largeDesktop, mobile, smallDesktop, tablet } = setPaginationSlide(assetFormat);

  const { slideWidth, slideHeight } = (() => {
    if (assetFormat === 'small' || carouselWidth <= 767) {
      return { slideWidth: 300, slideHeight: 300 };
    } else if (assetFormat === 'medium') {
      return { slideWidth: 560, slideHeight: 560 };
    } else if (assetFormat === 'widescreen' && carouselWidth >= 768 && carouselWidth <= 1023) {
      return { slideWidth: 700, slideHeight: 394 };
    } else if (assetFormat === 'widescreen' && carouselWidth >= 1024 && carouselWidth <= 1439) {
      return { slideWidth: 800, slideHeight: 450 };
    }
    return { slideWidth: 1000, slideHeight: 563 };
  })();

  if (carouselWidth <= 767) {
    return {
      slideWidth,
      slideHeight,
      slidesPerPage: mobile,
      slideActive,
      paginationPage: slideActive + 1,
      paginationCount: slidesTotal,
      paginationShow,
    };
  }

  if (carouselWidth >= 768 && carouselWidth <= 1023) {
    const slidesPerPage = tablet;
    const paginationCount = Math.ceil(slidesTotal / slidesPerPage);
    const _slideActive = Math.floor(slideActive / slidesPerPage) * slidesPerPage;
    const paginationPage = _slideActive / slidesPerPage + 1;
    return {
      slideWidth,
      slideHeight,
      slidesPerPage,
      slideActive: _slideActive,
      paginationPage,
      paginationCount,
      paginationShow,
    };
  }

  if (carouselWidth >= 1024 && carouselWidth <= 1439) {
    const slidesPerPage = smallDesktop;
    const paginationCount = Math.ceil(slidesTotal / slidesPerPage);
    const _slideActive = Math.floor(slideActive / slidesPerPage) * slidesPerPage;
    const paginationPage = _slideActive / slidesPerPage + 1;
    return {
      slideWidth,
      slideHeight,
      slidesPerPage,
      slideActive: _slideActive,
      paginationPage,
      paginationCount,
      paginationShow,
    };
  }

  if (carouselWidth >= 1440 && carouselWidth <= 1919) {
    const slidesPerPage = desktop;
    const paginationCount = Math.ceil(slidesTotal / slidesPerPage);

    const _slideActive = Math.floor(slideActive / slidesPerPage) * slidesPerPage;
    const paginationPage = _slideActive / slidesPerPage + 1;

    return {
      slideWidth,
      slideHeight,
      slidesPerPage,
      slideActive: _slideActive,
      paginationPage,
      paginationCount,
      paginationShow,
    };
  }

  if (carouselWidth >= 1920) {
    const slidesPerPage = largeDesktop;
    const paginationCount = Math.ceil(slidesTotal / slidesPerPage);
    const _slideActive = Math.floor(slideActive / slidesPerPage) * slidesPerPage;
    const paginationPage = _slideActive / slidesPerPage + 1;
    return {
      slideWidth,
      slideHeight,
      slidesPerPage,
      slideActive: _slideActive,
      paginationPage,
      paginationCount,
      paginationShow,
    };
  }

  return {
    slideWidth: 300,
    slideHeight: 300,
    slidesPerPage: 1,
    slideActive: 0,
    paginationPage: 1,
    paginationCount: 1,
    paginationShow,
  };
};
